module.exports = __webpack_public_path__ + "fonts/41db5f5406168140f3bac715979f8f36-Roboto-BoldItalic.ttf";